var zh = {
    name01: "智能柜概况",
    name02: "操作记录",
    name03: "领取记录",
    name04: "归还记录",
    name05: "待归还试剂记录",
    name06: "待注销试剂记录",
    name07: "库存不足信息",
    name08: "逾期未归还记录",
    name09: "即将过期试剂",
    name10: "归还未称重记录",
    name11: "人员管理",
    name12: "试剂管理",
    name13: "在库试剂",
    name14: "注销申请",
    name15: "违规管理",
    name16: "查找",
    name17: "报表管理",
    name18: "化学品月报表",
    name19: "危险化学品月报表",
    name20: "危险化学品领用报表",
    name21: "系统设置",
    name22: "公司信息",
    name23: "学院信息",
    name24: "违规条件",
    name25: "试剂分类",
    name26: "试剂配置",
    name27: "厂商配置",
    name28: "设备状态",
    name29: "邮件配置",
    name30: "APK升级",
    name31: "智能柜端日志",
    name32: "申请管理",
    name33: "我的申请",
    name34: "申请处理",
    name35: "Excel导入",
    name36: "手持机盘点记录",
    name37: "全部",
    name38: "返回",
    name39: "更多筛选(展开)",
    name40: "更多筛选(收起)",
    name41: "保存",
    name42: "保存并提交",
    main: {
        name01: "智能柜管理系统",
        name02: "检索",
        name03: "添加",
        name04: "编辑",
        name05: "删除",
        name06: "操作",
        name07: "取 消",
        name08: "确 定",
        name09: "是",
        name10: "否",
        name11: "开始时间",
        name12: "结束时间",
        name13: "全部",
        name14: "无法连接到服务器，请检查网络!",
        name15: "您无权访问系统，重新登陆或者联系管理员!",
        name16: "批量处理",
        name17: "标签打印",
        name18: "张",
        name19: "编辑选中",
        name20: "删除选中",
        name21: "展示列",
        name22: "更多操作",
        name23: '打印',
        name24: "详情",
        name25: "关闭",
        name26: "未选",
        name27: "下一步",
        name28: "上一步",
        name29: "提交",
        name30: "暂无数据",
        name31: '添加成功',
        name32: "入库导出",
        name33: "退回",
        name34: "授权权限",
        name35: "查看权限",
        name36: "添加子项",
        name37: "单个添加",
        name38: "批量添加",
        name39: "查看详情",
        name40: "编辑柜门",
        name41: "更多设置",
        name42: "编辑柜子",
        name43: "功能",
        name44: "远程盘点",
        name45: "同步人脸",
        name46: "查看视频",
        name47: "查看库存",
        name48: "指定智能柜",
        name49: "全选",
        enable: "启用",
        disable: "禁用",


    },
    login: {
        name1: "智能柜管理系统",
        name2: "登录",
        name3: "账号/手机号",
        name4: "密码",
        name5: "账号/手机号不能为空",
        name6: "密码不能为空",
        name7: "化学品智能试剂柜管理系统V2.1.0",
        name8: "修改密码",
        name9: "退出登录",
        name10: "旧密码",
        name11: "新密码",
        name12: "确定密码",
        name13: "统一身份认证",

    },
    cabinet: {
        name01: "编号",
        name02: "请输入智能柜编号",
        name03: "名称",
        name04: "请输入智能柜名称",
        name05: "是否多门柜",
        name06: "请输入柜门总数",
        name07: "智能柜类型",
        name08: "请选择智能柜类型",
        name09: "智能柜控制类型",
        name10: "请选择智能柜控制类型",
        name11: "控制柜",
        name12: "请选择控制柜",
        name13: "存放分类",
        name14: "请选择危险分类",
        name15: "公司",
        name16: "请选择保管公司",
        name17: "学院",
        name18: "请选择保管学院",
        name19: "位置",
        name20: "请输入保管场位置",
        name21: "容量不能为空",
        name22: "容量必须为正整数",
        name23: "RFID柜",
        name24: "条码柜",
        name25: "存储柜",
        name26: "控制柜",
        name27: "一体柜",
        name28: "智能柜编号不能为空",
        name29: "智能柜名称不能为空",
        name30: "编辑智能柜",
        name31: "添加智能柜",
        name32: "注销此智能柜",
        name33: "门锁",
        name34: "风扇",
        name35: "库存",
        name36: "液体",
        name37: "固体",
        name38: "今日操作",
        name39: "今日借出",
        name40: "今日归还",
        name41: "请选择柜门",
        name42: "编辑信息",
        name43: "今日使用",
        name44: "查看库存",
        name45: "温度",
        name46: "湿度",
        name47: "VOC",
        name48: "智能柜",
        name49: "确认注销该智能柜信息！",
        name50: "注销智能柜",
        name51: "删除智能柜信息成功!",
        name52: "在线",
        name53: "离线",
        name54: "排风扇",
        name55: "智能柜状态",
        name56: "总设备数(台)",
        name57: "总库存数(瓶)",
        name58: "今日数据",
        name59: "今日特别提示",
        name60: "今日操作数",
        name61: "今日异常数",
        name62: "今日领取数",
        name63: "今日归还数",
        name64: "待归还试剂",
        name65: "待注销试剂",
        name66: "库存不足",
        name67: "逾期未归还",
        name68: "即将过期",
        name69: "归还未称重",
        name70: "次",
        name71: "个",
        name72: "瓶",
        name73: "类型",
        name74: "重量",
        name75: "所有智能柜",
        name76: "便捷检索编号",
        name77: "当前容量",
        name78: "总容量",
        name79: "刷新",
        name80: "其他配置",
        name81: "请输入其他配置(建议使用JSON字符串)",
        name82: "排序",
        name83: "智能柜序列号",
        name84: "是否有温度传感器",
        name85: "是否有湿度传感器",
        name86: "是否智能锁",
        name87: "是否有风机",
        name88: "是否有VOC传感器",
        name89: "位置简称",
        name90: "请输入存放位置的简称",
        name91: "普通柜",
        name92: "是否有摄像头",
        name93: "摄像头序列号",
        name94: "摄像头IP",
        name95: "是否监管",
        name96: "锁连接类型",
        name97: "锁连接地址",
        name98: "请输入锁连接地址",
        name99: "锁连接端口",
        name100: "请输入锁连接端口",
        name101: "IO端口号",
        name102: "请输入IO端口号",
        name103: "智能柜门",
        name104: "请选择智能柜门",
        name105: '展示?',
        name106: "请选择柜子类型",
        name107: "异常",
        name108: "下属共",
        name109: "台智能柜",
        name110: "确定是否远程盘点！",
        name111: "盘点成功!",
        name112: "存放属性",
        name113: "请选择存放属性",
        name114: "场所设置",
        name115: "是否展示",
        name116: "存储柜（有屏）",
        name117: "存储柜（无屏）",
        name118: "MQ连接(默认)",
        name119: "WIFI继电器",
        name120: "独立钥匙盒",
        name121: "蓝牙锁",
        name122: "确定同步人脸信息！",
        name123: "同步成功!",
        name124: "实验室",
        name125: "仓库",
        name126: "无需监管",
        name127: "1次验证",
        name128: "2次验证",
    },
    door: {
        name01: "柜门名称",
        name02: "柜门编号",
        name03: "编辑柜门信息",
        name04: "修改成功!",
        name05: "柜门",
        name06: "确认授权",
        name07: "确认取消授权",
        name08: "智能柜",
        name09: '请选择入库柜门',
        name10: '入库柜门',

    },
    user: {
        name01: "用户信息:",
        name02: "用户卡号",
        name03: "请输入卡号",
        name04: "用户姓名",
        name05: "请输入姓名",
        name06: "邮箱",
        name07: "请输入邮箱",
        name08: "用户工号",
        name09: "请输入工号",
        name10: "手机号",
        name11: "请输入手机号",
        name12: "学院",
        name13: "请选择学院",
        name14: "密码设置:",
        name15: "登录名",
        name16: "请输入登录名",
        name17: "密码",
        name18: "请输入密码",
        name19: "密码确认",
        name20: "请再次输入密码",
        name21: "使用权限:",
        name22: "请选择角色",
        name23: "领用权限",
        name24: "请选择危险分类",
        name25: "授权",
        name26: "授权到期时间",
        name27: "选择授权到期时间",
        name28: "卡号不能为空",
        name29: "登录名不能为空",
        name30: "密码长度不能小于6位",
        name31: "两次密码不一致",
        name32: "请输入姓名",
        name33: "请输入正确邮箱",
        name34: "usiname不能为空",
        name35: "请输入正确手机号",
        name36: "不能为空",
        name37: "不能为空",
        name38: "编辑人员",
        name39: "添加人员",
        name40: "修改用户信息成功!",
        name41: "添加用户信息成功!",
        name42: "确认删除该条人员信息！",
        name43: "删除人员信息",
        name44: "删除人员信息成功!",
        name45: "管理员",
        name46: "操作员",
        name47: "角色",
        name48: "工号/用户名",
        name49: "编辑开门权限",
        name50: "开门",
        name51: "*",
        name52: "状  态",
        name53: "试剂负责人",
        name54: "试剂领用人",
        name55: "请选择状态",
        name56: "请选择负责人",
        name57: "请选择领用人",
        name58: "人员信息",
        name59: "试剂领用申请审批成功后，可打开的柜门列表",
        name60: "授权",
        name61: "管理后台手动授权，可打开的柜门列表",
        name62: "默认",
        name63: "智能柜默认授权开门的柜门列表",
        name64: "卡号不能以0开头",
        name65: "开门权限",
        name66: '是否启用',
        name67: "请输入用户名",
        name68: "照片MD5",
        name69: "照片",
        name70: "是否有特征值",
        name71: "确定删除此条人脸信息?",
        name72: "删除人脸信息",
        name73: "上传照片",
        name74: "编辑人脸信息",
        name75: "添加人脸信息",
        name76: "用户",
        name77: "确定要删除嘛?",
        name78: "角色名称",
        name79: "角色等级",
        name80: "请输入角色名称",
        name81: "请输入排序",
        name82: '等级',
        name83: "请输入等级",
        name84: "权限列表信息",
        name85: "全选/全不选",
        name86: "加载中，请稍候",
        name87: "编辑角色信息",
        name88: "添加角色信息",
        role_code: "角色标识",
        input_role_code: "请输入角色标识",
        please_select_status: "请选择用户状态",
        user_status: "用户状态"



    },
    materiel: {
        name01: "试剂信息",
        name02: "批次号",
        name03: "请输入批次号",
        name04: "RFID号",
        name05: "请输入RFID编号",
        name06: "称重",
        name07: "是否需要称重",
        name08: "毛重",
        name09: "请输入毛重",
        name10: "净含量",
        name11: "请输入净含量",
        name12: "瓶子重量",
        name13: "请输入瓶子重量",
        name14: "入库信息",
        name15: "生产日期",
        name16: "选择生产日期",
        name17: "有效期",
        name18: "选择有效日期",
        name19: "厂商",
        name20: "请选择厂商",
        name21: "备注",
        name22: "请输入备注",
        name23: "是否注销",
        name24: "* 为必填项",
        name25: "RFID编号不能为空",
        name26: "请输入瓶子重量",
        name27: "请输入非负数",
        name28: "请输入毛重",
        name29: "请输入净含量",
        name30: "请输入密度",
        name31: "请输入规格",
        name32: "编辑试剂",
        name33: "添加试剂",
        name34: "确定要注销该试剂吗？",
        name35: "确定",
        name36: "取消",
        name37: "提示",
        name38: "确认删除该条试剂信息!",
        name39: "删除试剂信息",
        name40: "删除试剂信息成功!",
        name41: "品名/CAS号",
        name42: "注销时间",
        name43: "最后记录时间",
        name44: "拷贝",
        name45: "权限",
        name46: "瓶子重量不能小于0!",
        name47: "入库时间",
        name48: "注销申请",
        name49: "已注销试剂",
        name50: "申请人",
        name51: "申请时间",
        name52: "审核状态",
        name53: "未审核",
        name54: "审核通过",
        name55: "审核未通过",
        name56: "审核人",
        name57: "审核时间",
        name58: "通过",
        name59: "拒绝",
        name60: "品名/英文名/CAS编号",
        name61: "请选择品名",
        name62: "分布图",
        name63: "智能柜中有",
        name64: "件试剂",
        name65: "Excel导出",
        name66: "分类",
        name67: "净含量",
        name68: "总瓶数",
        name69: "详情",
        name70: "预警",
        name71: "瓶",
        name72: "试剂归还时未称重",
        name73: "试剂",
        name74: "天后即将过期",
        name75: "试剂已过期",
        name76: "分布信息",
        name77: "Barcode",
        name78: "Please enter Barcode",
        name79: "Location",
        name80: "Please enter Location",
        name81: "Short Location",
        name82: "Please enter Short Location",
        name83: "Please select the custodian location",
        name84: "Owner",
        name85: "Please select the shortLocation",
        name86: "Please select the owner",
        name87: "按编号展示",
        name88: "按品名展示",
        name89: "智能柜负责人",
        name90: "请选择智能柜负责人",
        name91: "瓶重参考信息",
        name92: "编辑内容:",
        name93: "负责人",
        name94: "请选择负责人",
        name95: "是否称重",
        name96: "入库柜",
        name97: "请选择入库柜",
        name98: "批量入库",
        name99: "负责人信息",
        name100: "试剂配置信息",
        name101: "试剂详情信息",
        name102: "请选择负责人信息",
        name103: "请选择试剂配置信息",
        name104: "位置信息",
        name105: "您确定要删除此试剂吗?",
        name106: "请完成第一项负责人和部门的选择",
        name107: "请完成第二项试剂配置的选择",
        name108: "没找到配置信息？请先",
        name109: "添加配置",
        name110: "请填写试剂详情信息",
        name111: "净含量和瓶重必填一个!",
        name112: "多门柜柜门不能为空！",
        name113: "学校/部门",
        name114: "品牌名"

    },
    error: {
        name01: "版权所有",
        name02: "请检查您输入的网址是否正确，请点击以下按钮返回主页或者发送错误报告",
        name03: "返回首页",
        name04: "XX说这个页面你不能进......",
    },
    alarm: {
        name01: "请选择智能柜",
        name02: "人员工号/姓名/用户名/试剂名称",
        name03: "人员",
        name04: "智能柜编号",
        name05: "事件",
        name06: "时间",
        name07: "删除选中",
        name08: "删除所有",
        name09: "所有智能柜",
        name10: "确认删除违规信息!",
        name11: "删除违规信息",
        name12: "删除违规信息成功!",
        name13: "处理意见",
        name14: "已处理",
        name15: "未处理",
        name16: "是否记录",
        name17: "是否通知",
        name18: "阈值",
        name19: "通知类型",
        name20: "通知对象类型",
        name21: "通知人员",
        name22: "上报人",
        name23: "上报时间",
        name24: "上报说明",
        name25: "上报图片",
        name26: "处理",
        name27: "添加异常标签",
        name28: "编辑异常标签",
        name29: "请输入处理意见",
        name30: "请输入异常类型名称",
        name31: "处理违规记录",
        name32: "是否开启通知",
        name33: "记录类型",
        name34: "未填写",
        name35: "违规",
        name36: "预警",
        name37: "通知对象",
        name38: "处理异常",
        name39: "异常标签名称不能为空!",
        name40: "确实删除该异常标签",
        name41: "删除异常标签",
    },
    search: {
        name01: "试剂查找",
        name02: "人员名下试剂查找",
        name03: "RFID编号/品名/CAS号",
        name04: "RFID编号",
        name05: "状态",
        name06: "未借出",
        name07: "已借出",
        name08: "已采购",
        name09: "位置",
        name10: "最后接触人员",
        name11: "最后记录时间",
        name12: "流转详情",
        name13: "点击查看",
        name14: "人员工号/姓名/用户名",
        name15: "用户名",
        name16: "姓名",
        name17: "当前持有试剂数量",
        name18: "借用试剂数量",
        name19: "借用次数",
        name20: "归还次数",
        name21: "流转信息",
        name22: "名称:",
        name23: "编号:",
        name24: "状态:",
        name25: "未借出",
        name26: "柜中:",
        name27: "净含量:",
        name28: "净含量",
        name29: "未称重",
        name30: "已采购",
        name31: "入柜",
        name32: "借出",
        name33: "归还",
        name34: "注销",
        name35: "试剂查找",
        name36: "申请",
        name37: "审核",
    },
    report: {
        name01: "危 险 化 学 品 月 报 表",
        name02: "危 险 化 学 品 领 用 报 表",
        name03: "化 学 品 月 报 表",
        name04: "化 学 品 库 存 报 表",
        name05: "日期",
        name06: "入库量",
        name07: "出库量",
        name08: "在库量",
        name09: "试剂编号",
        name10: "操作人",
        name11: "使用量",
        name12: "操作类型",
        name13: "智能柜名称",
        name14: "请选择试剂",
        name15: "按单瓶展示",
        name16: "按单次展示",
        name17: "场所",
        name18: "按品名分组",
        name19: "按品名分组",
        name20: "公安台账",
        name21: "监管人",
        name22: "事由",
        name23: "监管人",
        name24: "剩余量",
        name25: "请输入试剂名/RFID",
        name26: "请选择操作类型",
        name27: "请选择操作人",
        name28: "按时间排序",
        name29: "操作内容",
        name30: "查看录像",
        name31: "请输入试剂品名",
        amount_purchased:"采购量",
        cancellation_amount:"注销量",
        adjustment_amount:"调整量",
        total_margin:"总余量",
        total_quantity_in_storage:"总在库量"
    },
    company: {
        name01: "公司名称",
        name02: "编辑公司信息",
        name03: "添加公司信息",
        name04: "请输入公司名称!",
        name05: "公司名称不能为空",
        name06: "删除公司信息",
        name07: "确认删除该条公司信息!",
        name08: "删除公司信息成功!",
        name09: "添加新公司信息",
        name10: "功能配置项",
        name11: "部门名称",
        name12: "配置项",
        name13: "配置名",
        name14: "配置KEY",
        name15: "配置类型",
        name16: "是否默认",
        name17: "填写要求",
        name18: "配置值",
        name19: "编辑系统配置项信息",
        name20: "添加系统配置项信息",
        name21: "通用配置",
        name22: "仅超管配置",
        name23: "请选择公司",
        name24: "请选择配置类型",
        name25: "请输入key",
        name26: "是否仅超管配置",
        name27: "用户名称",
        name28: "公司类型",
        name29: "编辑新公司信息",
    },
    department: {
        name01: "学院名称",
        name02: "编辑",
        name03: "添加",
        name04: "请输入名称",
        name05: "名称不能为空",
        name06: "删除信息",
        name07: "确认删除该条信息!",
        name08: "删除信息成功!",
        name09: '请选择部门/学院',
        name10: "学号",
        name11: "请输入学号",
        name12: "学院信息",
        name13: "部门",
        name14: "请选择部门",
        name15: "工号",
        name16: "请输入工号",
        name17: '部门信息',


    },
    setting: {
        name01: "预警项",
        name02: "数据",
        name03: "通知固定邮箱",
        name04: "是否通知违规者",
        name05: "库存不足比列(%)",
        name06: "管理员试剂领用上限",
        name07: "操作员试剂领用上限",
        name08: "试剂逾期未归还(小时)",
        name09: "在柜内长时间闲置上限(天)",
        name10: "柜体打开时间上限(分钟)",
        name11: "未称重是否记录",
        name12: "取得非法的试剂是否记录",
        name13: "归还前时间段内完成称重(秒)",
        name14: "有效期前时间段过期预警(天)",
        name15: "小时",
        name16: "天",
        name17: "分",
        name18: "请输入库存不足比例(%)",
        name19: "库存不足比例通知邮箱",
        name20: "请输入库存比例通知邮箱(多个邮箱以;隔开)",
        name21: "请输入管理员试剂领用上限",
        name22: "管理员试剂领用上限通知邮箱",
        name23: "请输入管理员试剂领用上限通知邮箱(多个邮箱以;隔开)",
        name24: "A管理员名试剂领用上限是否通知违规人",
        name25: "请输入操作员试剂领用上限",
        name26: "操作员试剂领用上限通知邮箱",
        name27: "请输入操作员试剂领用上限通知邮箱(多个邮箱以;隔开)",
        name28: "操作员试剂领用上限是否通知违规人",
        name29: "请输入试剂逾期未归还上限",
        name30: "试剂逾期未归还通知邮箱",
        name31: "请输入试剂逾期未归还通知邮箱(多个邮箱以;隔开)",
        name32: "试剂逾期未归还是否通知违规人",
        name33: "请输入在柜内长时间闲置上限",
        name34: "在柜内长时间闲置上限通知邮箱",
        name35: "请输入在柜内长时间闲置上限通知邮箱(多个邮箱以;隔开)",
        name36: "柜体打开时间上限",
        name37: "柜体打开时间上限通知邮箱",
        name38: "请输入试剂逾期未归还通知邮箱(多个邮箱以;隔开)",
        name39: "柜体打开时间上限是否通知违规人",
        name40: "请输入归还前时间段内完成称重(单位秒)",
        name41: "归还前时间未称重通知邮箱",
        name42: "请输入归还前时间未称重通知邮箱(多个邮箱以;隔开)",
        name43: "归还前时间未称重是否通知违规人",
        name44: "有效期前通知邮箱",
        name45: "请输入有效期前通知邮箱(多个邮箱以;隔开)",
        name46: "未称重通知邮箱",
        name47: "请输入未称重通知邮箱(多个邮箱以;隔开)",
        name48: "未称重是否通知违规人",
        name49: "取得非法的试剂是否记录",
        name50: "取得非法的试剂通知邮箱",
        name51: "请输入得非法的试剂通知邮箱(多个邮箱以;隔开)",
        name52: "得非法的试剂是否通知违规人",
        name53: "管理员试剂领用上限不能为空",
        name54: "管理员试剂领用上限不能为负",
        name55: "试剂逾期未归还上限不能为空",
        name56: "试剂逾期未归还上限不能为负",
        name57: "柜体打开时间上限不能为空",
        name58: "柜体打开时间上限不能为负",
        name59: "在柜内长时间闲置上限不能为空",
        name60: "在柜内长时间闲置上限不能为负",
        name61: "操作员剂领用上限不能为空",
        name62: "操作员剂领用上限不能为负",
        name63: "智能柜中存放数量上限不能为空",
        name64: "智能柜中存放数量上限不能为负",
        name65: "秒",
        name66: "预警项配置",
        name67: "VOC阈值",
        name68: "VOC告警通知邮箱",
        name69: "VOC告警通知邮箱(多个邮箱以;隔开)",
        name70: "开门超时时间",
        name71: "请输入开门超时时间",
        name72: "温度预警上限",
        name73: "请输入温度预警上限",
        name74: "温度预警下限",
        name75: "请输入温度预警下限",
        name76: "湿度预警上限",
        name77: "请输入湿度预警上限",
        name78: "湿度预警下限",
        name79: "请输入湿度预警下限",
        name80: "VOC预警上限",
        name81: "请输入VOC预警上限",
        name82: "最大存放量",
        name83: "请输入最大存放量设置",
        name84: "是否默认授权开门",
        name85: "是否默认授权开门",
        name86: "跟随智能柜",
        name87: "是否开启属性冲突检测",
        name88: "跟随系统",
        name89: "是否授权给子部门",
        name90: "是否开启试剂属性冲突检测",
        name91: "系统报警连续推送的间隔时间(s)",
        name92: "配置项",
        name93: "配置数据",
        name94: "选取文件",
    },
    danger: {
        name01: "名称",
        name02: "请输入危险分类名称",
        name03: "编辑危险分类配置",
        name04: "添加危险分类配置",
        name05: "确认删除该条危险分类配置信息！",
        name06: "删除危险分类配置信息",
        name07: "删除危险分类配置信息成功!",
        name08: "危险分类名称不能为空!",
        name09: "是否是危险化学品",
        name10: "是否是管制分类",
        name11: "请输入危险分类编号",
        name12: "管制分类",
    },
    cas: {
        name01: "品名/英文名/CAS编号",
        name02: "品名",
        name03: "英文名",
        name04: "CAS编号",
        name05: "MSDS",
        name06: "形态",
        name07: "液体(毫升)",
        name08: "固体(克)",
        name09: "密度",
        name10: "规格",
        name11: "危险分类",
        name12: "其他描述",
        name13: "请输入品名",
        name14: "请输入英文名",
        name15: "请输入CAS编号",
        name16: "请选择试剂形态",
        name17: "液体密度(克/毫升)",
        name18: "请输入规格(克)",
        name19: "请输入规格(毫升)",
        name20: "请选择危险分类",
        name21: "克/毫升",
        name22: "请输入其他描述",
        name23: "编辑品名配置",
        name24: "添加品名配置",
        name25: "确认删除该条品名配置信息!",
        name26: "删除品名配置信息",
        name27: "删除品名配置信息成功!",
        name28: "品名名称不能为空!",
        name29: "毫升",
        name30: "克",
        name31: "MSDS URL",
        name32: "Sample Name",
        name33: "Sample Name in Chinese",
        name34: "Please enter Sample Name",
        name35: "Please enter Sample Name in Chinese",
        name36: "中文别名",
        name37: "英文别名",
        name38: "请输入品名中文别名",
        name39: "请输入品名英文别名"




    },
    manufacturer: {
        name01: "名称",
        name02: "厂商名称",
        name03: "厂商编码",
        name04: "联系人",
        name05: "联系电话",
        name06: "请输入厂商名称",
        name07: "请输入厂商编码",
        name08: "请输入联系人",
        name09: "请输入联系方式",
        name10: "厂商名称不能为空",
        name11: "编辑厂商配置",
        name12: "添加厂商配置",
        name13: "确认删除该条厂商配置信息！",
        name14: "删除厂商配置信息",
        name15: "删除厂商配置信息成功!",
    },
    sensor: {
        name01: "字段名称",
        name02: "是否显示",
        name03: "显示",
        name04: "隐藏",
        name05: "名称",
    },
    mail: {
        name01: "邮件测试",
        name02: "邮件配置",
        name03: "数据",
        name04: "邮件服务地址",
        name05: "邮件服务端口",
        name06: "邮箱",
        name07: "邮箱密码",
        name08: "是否启用SSL",
        name09: "是否是Exchange邮件服务",
        name10: "修改设置成功!",
        name11: "请输入邮件服务地址",
        name12: "请输入邮件服务端口",
        name13: "请输入邮箱",
        name14: "请输入邮箱密码",
        name15: "测试邮箱",
        name16: "请输入测试邮箱地址",
        name17: "邮件发送成功!",
        name18: "邮件"
    },
    apk: {
        name01: "APK版本号/名称",
        name02: "版本",
        name03: "版本地址",
        name04: "点击下载",
        name05: "版本描述",
        name06: "上传者",
        name07: "上传时间",
        name08: "APK文件",
        name09: "只能上传APK文件，将文件拖到此处，或",
        name10: "点击上传",
        name11: "APK版本名称",
        name12: "请输APK版本名称",
        name13: "APK描述",
        name14: "请输APK描述",
        name15: "APK版本名称不能为空!",
        name16: "编辑APK版本信息",
        name17: "添加APK版本信息",
        name18: "APK文件上传成功!",
        name19: "确认删除该条APK版本信息!",
        name20: "删除APK版本信息",
        name21: "删除APK版本信息成功!",
        name22: "下载地址",
        name23: "请输入下载地址",
        name24: "APK类型",
        name25: "请选中APK类型"
    },
    log: {
        name01: "智能柜编号",
        name02: "日志名称",
        name03: "上传服务器时间",
        name04: "下载日志",
        name05: "认删除该条日志信息!",
        name06: "删除日志信息",
        name07: "删除日志信息成功!",
    },
    apply: {
        name01: "开门申请",
        name02: "注销申请",
        name03: "申请通过",
        name04: "审核拒绝",
        name05: "审核备注",
        name06: "请输入审核备注",
        name07: "删除申请信息",
        name08: "确定删除申请信息!",
        name09: "删除申请消息成功!",
        name10: "申请",
        name11: "申请注销",
        name12: "确定申请注销该试剂!",
        name13: "申请理由",
        name14: "请输入申请理由!",
        name15: "有效次数",
        name16: "请选择有效次数!",
    },
    materielDoor: {
        name01: "编辑试剂指定存放信息",
        name02: "试剂信息",
        name03: "存放位置",
        name04: "确定存放到",
        name05: "智能柜!",
        name06: "确定取消存放到",
        name07: "修改试剂指定存放信息成功！",
        name08: "请选择存放位置",
        name09: "指定位置柜",
        name10: "请选择指定位置柜",
        name11: "指定柜门",
        name12: '请选择指定柜门',
        name13: "是否立即入库"



    },
    inventory: {
        name01: "盘点人员",
        name02: "盘点时间",
        name03: "盘点柜子",
        name04: "盘点柜门",
        name05: "库存盘亏",
        name06: "库存盘盈",
        name07: "详情",
        name08: "请选择盘点柜",
        name09: "请选择盘点人员",
        name10: "试样名称",
        name11: "中文样本名称",
        name12: "CAS 号",
        name13: "条形码",
        name14: "RFID 号码",
        name15: "数量",
        name16: "所有者",
        name17: "位置",
        name18: "短距离",
        name19: "登记日期",
        name20: "位置(现在)",
        name21: "短距离(现在)",
        name22: "库存类型",
        name23: "试剂名",
        name24: "请选择库存类型",
        name25: "盘点结果",
        name26: '正常',
        name27: '试剂数量'
    },
    receive: {
        name01: '同意',
        name02: '不同意',
        name03: '点击详情',
        name04: '添加申请试剂',
        name05: '编辑申请信息',
        name06: "取消申请",
        name07: "审核驳回",
        name08: "审核通过",
        name09: "撤回申请",
        name10: "审核取消",


    },
    largeScreen: {
        name01: "智能柜可视化平台",
        name02: "进入后台系统",
        name03: "左滑",
        name04: "右滑",
        name05: "智能柜总数",
        name06: "试剂总数",
        name07: "人员总数",
        name08: "库存数据统计图",
        name09: "使用量数据统计图",
        name10: "违规记录",
        name11: "试剂分类",
        name12: "试剂属性",
        name13: "领取记录",
        name14: "操作记录",
        name15: "周日",
        name16: "周一",
        name17: "周二",
        name18: "周三",
        name19: "周四",
        name20: "周五",
        name21: "周六",
        name22: "周日",
        name23: "试剂名称",
        name24: "CAS号",
        name25: "RFID编号",
        name26: "负责人",
        name27: "净含量",
        name28: "瓶重",
        name29: "属性",
        name30: "分类",
        name31: "状态",
        name32: "已采购",
        name33: "在柜内",
        name34: "已借出",
        name35: "已注销",
        name36: "使用量",
        name37: '库存量',
        name38: ' 已采购'
    },
    attribute: {
        name01: "请选择试剂属性",
        name02: "冲突试剂",
        name03: "请选择冲突的试剂",
        name04: "系统默认",
        name05: "确认删除试剂配置信息",
        name06: " 注：删除后可能导致试剂分类与统计错误！",
        name07: "互斥属性",
        name08: "属性名称",
        name09: "请输入属性名称",
        name10: "请选择互斥属性",
        name11: "属性名称不能为空!",
        name12: "编辑试剂属性",
        name13: "添加试剂属性",
        name14: "确认删除该条试剂属性信息",
        name15: "删除试剂属性信息",
        name16: "删除成功",
        name17: "设置成功",
        name18: "编辑成功",
    },
    placeholder: {
        name01: '请输入内容',
        name02: "请选择",
        name03: '请输入'
    },
    keyBox: {
        name01: "钥匙名称",
        name02: "标识码",
        name03: "状态",
        name04: "开启",
        name05: "废弃",
        name06: "类型",
        name07: "普通钥匙",
        name08: "卡片",
        name09: "绑定智能柜",
        name10: "存放智能柜",
        name11: "存放智能柜门",
        name12: "钥匙状态",
        name13: "修改钥匙盒信息",
        name14: "添加钥匙盒信息",
        name15: "是否在柜内",
        name16: "状态类型",
        name17: "钥匙类型",



    },
    print: {
        name01: '打印机',
        name02: '请选择打印机',
        name03: '是否打印详情',
        name04: "打印机名称/IP",
        name05: "连接类型",
        name06: "网络",
        name07: "设备类型",
        name08: "Zebra RFID打印机",
        name09: "ZMIN RFID打印机",
        name10: "RD 条码打印机",
        name11: "打印深度",
        name12: "打印速度",
        name13: "端口",
        name14: "X轴偏移量",
        name15: "Y轴偏移量",
        name16: "关联智能柜",
        name17: "名称",
        name18: "打印机名称",
        name19: "请输入打印机名称",
        name20: "请选择类型",
        name21: "请输入设备类型",
        name22: "请输入打印深度",
        name23: "请输入打印速度",
        name24: "IP地址",
        name25: "请输入IP地址",
        name26: "端口号",
        name27: "请输入端口号",
        name28: "请输入X轴偏移量",
        name29: "请输入Y轴偏移量",
        name30: "选择打印模板",
        name31: "请选择关联智能柜",
        name32: "修改打印机信息",
        name33: "添加打印机信息",
        name34: "确定删除打印机信息!",
        name35: "删除打印机",
    },
    upload: {
        name01: '试剂文件',
        name02: '只能上传XLSX文件，将文件拖到此处，或',
        name03: '点击上传',
        name04: '下载模版',
        name05: '错误信息共计',
        name06: "条，请修改后重新上传！",
        name07: "错误原因",
        name08: "Excel行号",
        name09: "上传试剂",
        name10: "试剂导入成功!",
        name11: "上传文件只能是XLSX格式!",
        name12: "只上传Excel文件，将文件拖到此处，或者",
        name13: "错误信息",
        name14: "导入成功!",
        name15: "上传文件只能是XLSX格式",
        name16: "只能上传jpg/png文件",
        name17: "说明",
        name18: "1. 照片命名为用户姓名, 如：张三",
        name19: "2. 如果姓名有重复,需要添加唯一不重复的标识,使用下划线分割, 如: 张三_123"
    },
    msds: {
        name01: "CAS号/名称",
        name02: "化学品中文名",
        name03: "化学品英文名",
        name04: "安全技术说明书",
        name05: "第一部分：化学品名称",
        name06: "化学品中文名称：",
        name07: "化学品俗名：",
        name08: "化学品英文名称：",
        name09: "英文名称:",
        name10: "技术说明书编码：",
        name11: "生产企业名称：",
        name12: "地址：",
        name13: "生效日期:",
        name14: "第二部分：危险性概述",
        name15: " 危险性类别：",
        name16: "侵入途径：",
        name17: "健康危害：",
        name18: "环境危害：",
        name19: "燃爆危险：",
        name20: "第三部分：成分/组成信息",
        name21: "有害物成分",
        name22: "含量",
        name23: "第四部分：急救措施",
        name24: "皮肤接触：",
        name25: "眼睛接触：",
        name26: "吸入：",
        name27: "食入",
        name28: "第五部分：消防措施",
        name29: "危险特性：",
        name30: " 有害燃烧产物：",
        name31: "灭火方法：",
        name32: "第六部分：泄漏应急处理",
        name33: "应急处理：",
        name34: "第七部分：操作处置与储存",
        name35: " 操作注意事项：",
        name36: "储存注意事项：",
        name37: "第八部分：接触控制/个体防护",
        name38: " 中国MAC(mg/m3)：",
        name39: "前苏联MAC(mg/m3)：",
        name40: "监测方法：",
        name41: "工程控制：",
        name42: " 呼吸系统防护：",
        name43: "眼睛防护：",
        name44: "身体防护：",
        name45: "手防护：",
        name46: "其他防护：",
        name47: "第九部分：理化特性",
        name48: '外观与性状：',
        name49: "熔点(℃)：",
        name50: "相对密度(水=1)：",
        name51: "沸点(℃)：",
        name52: " 相对蒸气密度(空气=1)：",
        name53: "分子式：",
        name54: "分子量：",
        name55: "主要成分：",
        name56: "饱和蒸气压(kPa)：",
        name57: "燃烧热(kJ/mol)：",
        name58: "临界温度(℃)：",
        name59: "临界压力(MPa)：",
        name60: " 辛醇/水分配系数的对数值：",
        name61: "闪点(℃)：",
        name62: "爆炸上限%(V/V)：",
        name63: "引燃温度(℃)：",
        name64: "爆炸下限%(V/V)：",
        name65: "溶解性：",
        name66: "主要用途：",
        name67: "其它理化性质：",
        name68: "第十部分：稳定性和反应活性",
        name69: "稳定性：",
        name70: "禁配物：",
        name71: "避免接触的条件：",
        name72: "聚合危害：",
        name73: "分解产物：",
        name74: "第十一部分：毒理学资料",
        name75: "急性毒性：",
        name76: "亚急性和慢性毒性：",
        name77: "刺激性：",
        name78: "致敏性：",
        name79: "致突变性：",
        name80: "致畸性：",
        name81: "致癌性：",
        name82: "第十二部分：生态学资料",
        name83: "生态毒理毒性：",
        name84: " 生物降解性：",
        name85: " 非生物降解性：",
        name86: " 生物富集或生物积累性：",
        name87: ' 其它有害作用：',
        name88: "第十三部分：废弃处置",
        name89: "废弃物性质：",
        name90: " 废弃处置方法：",
        name91: " 废弃注意事项：",
        name92: "第十四部分：运输信息",
        name93: "危险货物编号：",
        name94: "UN编号：",
        name95: "包装标志：",
        name96: "包装类别：",
        name97: "包装方法：",
        name98: " 运输注意事项：",
        name99: "第十五部分：法规信息",
        name100: "法规信息：",
        name101: "第十六部分：其他信息",
        name102: "参考文献：",
        name103: "填表部门：",
        name104: "数据审核单位：",
        name105: "修改说明：",
        name106: "其他信息：",
        name107: "未找到相应MSDS",
        name108: "确定删除该条MSDS信息！",
        name109: "删除MSDS信息",
        name110: '删除成功',
    },
    purchaseOrder: {
        name01: "入库状态",
        name02: "采购单号",
        name03: "按选中采购单入库",
        name04: "按选中采购单导出",
        name05: "按选中采购单打印",
        name06: "批量导出",
        name07: "批量打印",
        name08: "采购单号",
        name09: "发起时间",
        name10: "审批中",
        name11: "审批失败",
        name12: "审批成功",
        name13: "取消审批",
        name14: "发起人",
        name15: "发起人联系方式",
        name16: "采购单联系方式",
        name17: "采购明细",
        name18: "课题组",
        name19: "项目准入编号",
        name20: "未入库",
        name21: "已入库",
        name22: "审批状态",
        name23: "已取消入库",
        name24: "入库成功",
    },
    video: {
        name01: "录像结束时间",
        name02: "录像开始时间",
        name03: "总时长",
        name04: "播放视频",
        name05: "视频列表"
    },
    approval: {
        name01: "试剂添加",
        name02: "试剂领用",
        name03: "试剂注销",
        name04: "采购申请",
        name05: "项目准入申请",
        name06: "补码申请",
        name07: "配置类型",
        name08: "全局配置",
        name09: "分类配置",
        name10: "配置名称",
        name11: "审批步骤",
        name12: "审核人",
        name13: "人员审核：",
        name14: "试剂负责人审核",
        name15: "实验室管理员审核 ",
        name16: "角色审核：  ",
        name17: "指定试剂",
        name18: "试剂柜负责人审核",
        name19: "审核步骤",
        name20: "确认删除该条审批流信息",
        name21: "步骤",
        name22: "点击选择试剂",
        name23: "是否仅本",
        name24: "编辑审批流",
        name25: "添加审批流",
        name26: "指定人员",
        name27: "指定角色",
        name28: "实验室管理员",
        name29: "试剂柜负责人",
        name30: "待审批",
        name31: "审批记录",
        name32: "审核详情",
        name33: "试剂配置详情",
        name34: "申请记录",
        name35: "添加补码申请",
        name36: "编辑补码申请",
        name37: "请输入补码原因",
        name38: "补码原因",
        name39: "操作码",
        name40: "审批详情",
        name41: "已申请",
        name42: "审批结果",
        name43: "已发出申请",
        name44: "待通知",
        name45: "已同意",
        name46: "已拒绝",
        name47: "撤销",
        name48: "项目名称",
        name49: "项目类型",
        name50: "本科生教学",
        name51: "研究生教学",
        name52: "创新类项目",
        name53: "科研类项目",
        name54: "实验项目准入编号",
        name55: "编辑项目准入申请",
        name56: "添加项目准入申请",
        name57: "撤回",
        name58: "试剂明细",
        name59: "试剂中文名称",
        name60: "试剂CAS号",
        name61: "记录",
        name62: "实验地点",
        name63: "实验日期",
        name64: "审批时间",
        name65: "化学品使用团队",
        name66: "采购试剂",
        name67: "采购详情",
        name68: "实验项目准入",
        name69: "采购联系人电话",
        name70: "费用编号",
        name71: "存放地点柜子",
        name72: "规格值",
        name73: "添加采购申请",
        name74: "申请审批",
        name75: "仅展示在柜内的试剂列表",
        name76: "添加实验室",
        name77: "编辑实验室",
        name78: "申请中",
        name79: "规格值",
        name80: "单位"
    },
    supplier: {
        name01: "供应商银行账号",
        name02: "供应商开户行",
        name03: "供应商联系人身份证",
        name04: "院内联系人身份证",
        name05: "院内联系人",
        name06: "院内联系人电话",
        name07: "许可证类型",
        name08: "许可证编号",
        name09: "许可证开始时间",
        name10: "许可证结束时间",
        name11: "附件",
        name12: "供应商姓名",
        name13: "供应商地址",
        name14: "供应商联系人姓名",
        name15: "供应商联系人电话",
        name16: "已确定",
        name17: "确认删除该条试剂属性信息!",
        name18: "化学品名称",
        name19: '供应商',
        name20: "供应商待确认",
        name21: "危化品经营许可证",
        name22: "供应商详情",
        name23: "待确定",
        name24: "附件类型",
        name25: "请选择附件类型",
        name26: "危化品明细",
        name27: "营业执照",
        name28: "供应商联系人不能为空!",
        name29: "供应商名称不能为空！",
        name30: "供应商确认",
        name31: "供应商下试剂明细",


    },
    permission: {
        name01: "菜单名称",
        name02: "请求方式",
        name03: "请求接口",
        name04: "校验方式",
        name05: "创建时间",
        name06: "修改时间",
        name07: "图标",
        name08: "编码",
        name09: "组件路径",


    },
    localSetting: {
        name01: "具体位置",
        name02: "选择上级",
        name03: "请输入具体位置",
        name04: "选择类型",
        name05: "添加场所",
        name06: "编辑场所"
    },
    confirm: {
        name01: "此次操作将撤销申请，是否继续？",
        name02: "是否需要继续申请？",
        name03: "是否需要继续录入？",
        name04: "退回此次采购单, 是否继续?",
        name05: "已取消退出",
        name06: "是否确认选中采购单进行入库",
        name07: "请填写危化品明细",
        name08: "审批拒绝时理由不能为空",
        name09: "品名不能为空",
        name10: "申请成功",

    },
    order: {
        name01: "订单号",
        name02: "课题组名称",
        name03: "课题组负责人姓名",
        name04: "请购人姓名",
        name05: "供应商名称",
        name06: "商品名称",
        name07: "品牌",
        name08: "货号",
        name09: "包装规格",
        name10: "单价",
        name11: '销售单位',
        name12: "总价",
        name13: '验收状态',
        name14: "收货状态",
        name15: "试剂入库",
        name16: "订单列表",
        name17: "试剂列表",






    }
};


export default zh



// WEBPACK FOOTER //
// ./src/assets/languages/zh.js